export const WELCOME_TICKET = {
  id: -1,
  subject: 'Welcome to the all new messages!',
  description:
    "Welcome to messages! This is a place where you can directly communicate with Collective Health's team of Member Advocates (around here, we call them MA's for short.)",
};
